/* eslint-disable import/no-cycle */
import { FC } from 'react'

import SearchDesktopCatDesc from './SearchDesktopCatDesc'
import SearchMobileCatDesc from './SearchMobileCatDesc'

export interface SearchCatDescriptionProps {
  catDescription?: string
  subCatDescription?: string
}

const SearchCatDescription: FC<SearchCatDescriptionProps> = ({
  catDescription,
  subCatDescription
}) => {
  return (
    <>
      <SearchMobileCatDesc
        catDescription={catDescription}
        subCatDescription={subCatDescription}
      />
      <SearchDesktopCatDesc
        catDescription={catDescription}
        subCatDescription={subCatDescription}
      />
    </>
  )
}

export default SearchCatDescription
